import React from 'react'
import { Partners } from '../../component/Partners/Partners'

export default function PartnersPage() {
  return (
    <>
      <Partners />
    </>
  )
}
